import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bcca-colleges-nagpur',
  templateUrl: './bcca-colleges-nagpur.component.html',
  styleUrls: ['./bcca-colleges-nagpur.component.scss']
})
export class BccaCollegesNagpurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
